import React, { useCallback } from "react";
import FileBrowser from "./FileBrowser";
import AzureService from "../../../service/azureService";
import { useParams } from "react-router-dom";

export default function AzureFileBrowser(props) {
  const { Workspace_id } = useParams();

  let { path, multipleFileSelection, container } = props;
  let fileName = multipleFileSelection ? [] : false;
  let pref = "/";

  //Adding or removing extra '/' and making complete prefix
  if (path && path !== "/") {
    if (multipleFileSelection) {
      const tempPathArr = [];

      path.split(",/").forEach((path, key) => {
        //Adding or removing extra '/' and making complete prefix
        if (path === "/") path = "";

        if (path) {
          if (path.startsWith("/")) path = path.substring(1);
          fileName.push(path.replace(container + "/", ""));

          if (!path.endsWith("/")) path = path.replace(fileName[key].split("/").pop(), "");

          if (path === "/") path = "";

          if (key === 0 && path) {
            if (pref) pref = pref + path;
            else if (path[0] === "/") pref = path;
            else pref = "/" + path;
          }
          tempPathArr.push("/" + path);
        }
      });

      // Check is files are selected from more than one folders then Browser will open with default container
      let uniquepathArr = [...new Set(tempPathArr)];
      if (uniquepathArr.length > 1) pref = `/${container}/`;
    } else {
      if (path.startsWith("/")) path = path.substring(1);
      fileName = path.replace(container + "/", "");

      if (!path.endsWith("/")) path = path.replace(fileName.split("/").pop(), "");

      if (path === "/") path = "";

      pref = pref + path;
    }
  }

  //Getting file and folder data
  const getData = useCallback(async ({ prefix, Stage_id }) => {
    if (prefix[0] === "/") prefix = prefix.substring(1);

    const azure = new AzureService();
    return await azure.getData({
      location: prefix,
      Stage_id,
    });
  }, []);

  //Download click
  const downloadClick = async ({ id, Stage_id }) => {
    const azure = new AzureService();
    const response = await azure.download(Workspace_id, {
      container,
      location: id,
      Stage_id,
    });

    if (response.success) window.location.href = response.data;
  };

  //Download button click
  const multipleDownload = async ({ name, files, Stage_id }) => {
    let count = 0;
    const downloadURL = function downloadURL(url) {
      const hiddenIFrameID = "hiddenDownloader" + count++;
      const iframe = document.createElement("iframe");
      iframe.id = hiddenIFrameID;
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      iframe.src = url;
    };

    const azure = new AzureService();
    const response = await azure.download(
      Workspace_id,
      {
        container,
        location: name,
        Stage_id,
      },
      { files: files.join(",") }
    );

    if (response.success) response.data.forEach((file) => downloadURL(file));
  };

  //Delete click
  const deleteClick = async ({ id, Stage_id, type }) => {
    const azure = new AzureService();
    return await azure.delete({
      container,
      location: id,
      Stage_id,
      type,
    });
  };

  //Delete Button click (Multiple files)
  const multipleDelete = async ({ name, Stage_id, type, files }) => {
    const azure = new AzureService();
    return await azure.delete({
      container,
      location: name,
      Stage_id,
      type,
      files,
    });
  };

  //Create Folder
  const createFolderClick = async ({ name, Stage_id }) => {
    const azure = new AzureService();
    return await azure.createFolder({
      container,
      location: name,
      Stage_id,
    });
  };

  return (
    <FileBrowser
      getData={getData}
      createFolderClick={createFolderClick}
      deleteClick={deleteClick}
      multipleDownload={multipleDownload}
      multipleDelete={multipleDelete}
      downloadClick={downloadClick}
      pref={pref}
      fileName={multipleFileSelection ? fileName.join(",/") : fileName}
      url={""}
      {...props}
      title="Azure Explorer"
      type="azure"
    />
  );
}
